var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlexible({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2324",
    "data-name": "Grupo 2324",
    transform: "translate(0 -11916)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1261",
    "data-name": "Rect\\xE1ngulo 1261",
    width: 48,
    height: 48,
    transform: "translate(0 11916)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2324-2",
    "data-name": "Grupo 2324",
    transform: "translate(3.961 11917.98)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2957",
    "data-name": "Trazado 2957",
    d: "M21.232,14.574a.99.99,0,0,1,0-1.4l4.251-4.251H15.866A.935.935,0,0,1,15,7.932a.935.935,0,0,1,.866-.99h9.616L21.232,2.69a.99.99,0,0,1,1.4-1.4l5.76,5.76a1.06,1.06,0,0,1,0,1.763l-5.76,5.76A.99.99,0,0,1,21.232,14.574Z",
    transform: "translate(12.728 -1)",
    fill: "#ec0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2958",
    "data-name": "Trazado 2958",
    d: "M7,9.574v19.2c0,2.991,3.592,5.334,8.178,5.334,7.126,0,8.178-4.829,8.178-4.829V9.574c0-2.991-3.592-5.334-8.178-5.334S7,6.583,7,9.574ZM9.045,19.5a10.376,10.376,0,0,0,6.134,1.8,10.377,10.377,0,0,0,6.134-1.8v2.87c0,1.514-2.519,3.2-6.134,3.2s-6.134-1.686-6.134-3.2Zm6.134-.33c3.615,0,6.134-1.687,6.134-3.2V13.1a10.377,10.377,0,0,1-6.134,1.8,10.377,10.377,0,0,1-6.134-1.8v2.87C9.045,17.488,11.563,19.174,15.178,19.174Zm0,12.8c-3.615,0-6.134-1.686-6.134-3.2v-2.87a10.376,10.376,0,0,0,6.134,1.8,10.377,10.377,0,0,0,6.134-1.8v2.87C21.312,30.288,18.793,31.975,15.178,31.975Zm6.134-22.4c0-1.514-2.519-3.2-6.134-3.2S9.045,8.06,9.045,9.574s2.519,3.2,6.134,3.2S21.312,11.087,21.312,9.574Z",
    transform: "translate(4.883 2.177)",
    fill: "#ec0000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2959",
    "data-name": "Trazado 2959",
    d: "M4.381,23.922H14a1,1,0,0,0,0-1.981H4.381l4.251-4.251a.99.99,0,1,0-1.4-1.4l-5.76,5.76a1.06,1.06,0,0,0,0,1.763l5.76,5.76a.99.99,0,1,0,1.4-1.4Z",
    transform: "translate(-1 13.708)",
    fill: "#ec0000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlexible);
export default __webpack_public_path__ + "static/media/flexible.e1b7acb2c0a1c74231c46bb632034cc9.svg";
export { ForwardRef as ReactComponent };